import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Upload, Button, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import ImgCrop from 'antd-img-crop';

const MAX_WIDTH = 1600;
const MAX_HEIGHT = 540;

const EditBannerPopup = ({ banner, visible, onCancel, onSave }) => {
  const token = localStorage.getItem('token');
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);

  useEffect(() => {
    if (visible && banner) {
      form.setFieldsValue(banner);
      setUploadSuccess(false);
      setFile(null);
    }
  }, [visible, banner, form]);

  const isValidURL = (url) => {
    const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
    return urlRegex.test(url);
  };

  const resizeImageToBannerSize = (file, callback) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = MAX_WIDTH;
        canvas.height = MAX_HEIGHT;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, MAX_WIDTH, MAX_HEIGHT);
        canvas.toBlob((blob) => {
          const newFile = new File([blob], file.name, { type: file.type });
          callback(newFile);
        }, file.type);
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  };

  const handleFileUpload = ({ file, onSuccess, onError }) => {
    resizeImageToBannerSize(file, (resizedFile) => {
      setFile(resizedFile);
      setUploadSuccess(true);
      onSuccess("Uploaded");
    });
  };

  const handleBeforeUpload = async (file) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => resolve(file); // All images accepted, we resize later
    });
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      if (values.url && !isValidURL(values.url)) {
        message.error("Invalid URL.");
        return;
      }

      const formData = new FormData();
      formData.append('id', banner.bannerid);
      formData.append('title', values.title);
      formData.append('description', values.description);
      formData.append('section', values.section);
      formData.append('position', values.position);
      formData.append('url', values.url);
      if (file) {
        formData.append('file', file);
      }

      onSave(Object.fromEntries(formData.entries())); // Send data to parent
      form.resetFields();
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  return (
    <Modal
      title="Edit Banner"
      open={visible}
      onCancel={onCancel}
      onOk={handleSave}
      okText="Save"
      cancelText="Cancel"
    >
      <Form form={form} layout="vertical">
        <Form.Item label="Title" name="title" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Description" name="description" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="URL" name="url">
          <Input />
        </Form.Item>
        <Form.Item label="Position" name="position">
          <Input />
        </Form.Item>
        <Form.Item label="Section" name="section">
          <select name="section" className="form-select">
            <option value="1">Main Banner (Section 1)</option>
            <option value="2">Section 2</option>
            <option value="3">Section 3</option>
            <option value="4">Section 4</option>
            <option value="5">Section 5</option>
            <option value="6">Section 6</option>
          </select>
        </Form.Item>

        {/* <Form.Item label="Upload New Image" name="file">
          <ImgCrop
            rotate
            aspect={1600 / 540}
            quality={1}
            cropShape="rect"
            modalTitle="Crop Image to 1600×540"
            modalWidth={800}
          >
            <Upload
              accept=".jpg,.jpeg,.png,.webp,.svg"
              customRequest={handleFileUpload}
              showUploadList={false}
              beforeUpload={handleBeforeUpload}
            >
              <Button icon={<UploadOutlined />}>
                Click to Upload
              </Button>
            </Upload>
          </ImgCrop>
          {uploadSuccess && (
            <div style={{ color: 'green', marginTop: 5 }}>Image ready for upload.</div>
          )}
        </Form.Item> */}
      </Form>
    </Modal>
  );
};

export default EditBannerPopup;
